import FuseAnimate from '@/@fuse/core/FuseAnimate';
import { AppBar } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import StyledTabs from '@shared/components/StyledTabs';
import { StyledTab } from 'shared/components/StyledTab';
import LivestreamingView from './LivestreamingView';
import LivestreamingHistory from './LivestreamingHistory';
import LivestreamingBlur from './LivestreamingBlur';
import CameraListing from './CameraListing/CameraListing';
import GradientButton from 'shared/components/GradientButton';
import CameraRegistration from './CameraRegistration';

const Livestreaming = () => {
	const history = useHistory();
	const location = useLocation();
	const currentSlug = location.pathname.split('/').pop();
	const [activeTab, setActiveTab] = React.useState(currentSlug);

	const handleChange = (_, newValue) => {
		setActiveTab(newValue);
		const basePath = location.pathname.split('/').slice(0, -1).join('/');
		history.replace(`${basePath}/${newValue}`);
	};

	useEffect(() => {
		const slug = location.pathname.split('/').pop();
		setActiveTab(slug);
	}, [location.pathname]);

	const handleCameraRegistration = () => {
		setActiveTab('camera-registration');
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div>
				<div className="flex items-center gap-16 bg-white shadow-lg">
					<AppBar className="shadow-none flex-1 z-[2]" position="static">
						<StyledTabs onChange={handleChange} value={activeTab} variant="scrollable">
							{/* <StyledTab
								className={`text-pd-base md:text-pd-lg ${activeTab === 'live-view' ? 'text-pd-blue' : ''}`}
								label="Live View"
								value="live-view"
							/>
							<StyledTab
								className={`text-pd-base md:text-pd-lg ${activeTab === 'history' ? 'text-pd-blue' : ''}`}
								label="History"
								value="history"
							/> */}
							<StyledTab
								className={`text-pd-base md:text-pd-lg ${activeTab === 'cameras' ? 'text-pd-blue' : ''}`}
								label="Camera Listings"
								value="cameras"
							/>
							{/* <StyledTab
								className={`text-pd-base md:text-pd-lg ${activeTab === 'blur' ? 'text-pd-blue' : ''}`}
								label="Blur"
								value="blur"
							/> */}
						</StyledTabs>
					</AppBar>
					<div className="mr-16">
						<GradientButton onClick={handleCameraRegistration} variant="light-blue">
							Camera Registration
						</GradientButton>
					</div>
				</div>

				<div className="overflow-auto mb-64 pb-64">
					{activeTab === 'live-view' ? <LivestreamingView /> : null}
					{activeTab === 'history' ? <LivestreamingHistory /> : null}
					{activeTab === 'cameras' ? <CameraListing /> : null}
					{activeTab === 'blur' ? <LivestreamingBlur /> : null}
					{activeTab === 'camera-registration' ? <CameraRegistration setActiveTab={setActiveTab} /> : null}
				</div>
			</div>
		</FuseAnimate>
	);
};

export default Livestreaming;
